import Vue from "vue";

import EditProfile from "./EditProfile.vue";

export function load() {
    const selector = "edit-profile";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(EditProfile, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
